import React from "react";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";

const RightNav = ({ onClick, disabled, className }) => {
  return (
    <button
      type='button'
      className={`image-gallery-icon image-gallery-right-nav ${className}`}
      disabled={disabled}
      onClick={onClick}
      aria-label='Previous Slide'
    >
      <ArrowRightIcon sx={{ fontSize: "50px" }} />
    </button>
  );
};

export default RightNav;
